import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { getSingleCoin } from "../../../redux/actions/Coingecko/getSingleCoin";

export const useSparklineChartData = (currencySymbol, timeRange = "24H") => {
  const dispatch = useDispatch();

  const [coinData, setCoinData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currencySymbol) return;

    let isSubscribed = true;
    setLoading(true);
    setError(null);

    dispatch(getSingleCoin(currencySymbol, timeRange))
      .then((data) => {
        if (isSubscribed) {
          setCoinData(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (isSubscribed) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      isSubscribed = false;
    };
  }, [dispatch, currencySymbol, timeRange]);


  // const chartData = useMemo(() => {
  //   if (!coinData?.data) return null;

  //   return coinData?.data;
  // }, [coinData]);

  const chartData = useMemo(() => {
    const prices = coinData?.data?.chart?.prices ?? [];

    return {
      // prices: prices.map(([, price]) => price),
      prices: prices,
      total_volume: coinData?.data?.total_volume ?? 0,
    };
  }, [coinData]);

  return {
    loading,
    error,
    chartData,
  };
};